import { render } from "./DataAppDIMReport.vue?vue&type=template&id=4dbe136a"
import script from "./DataAppDIMReport.vue?vue&type=script&lang=js"
export * from "./DataAppDIMReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ddv-home/DataAppDIMReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4dbe136a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4dbe136a', __exports__)) {
    api.reload('4dbe136a', __exports__)
  }
  
  module.hot.accept("./DataAppDIMReport.vue?vue&type=template&id=4dbe136a", () => {
    api.rerender('4dbe136a', render)
  })

}


export default __exports__